import React, { useCallback } from 'react';
import { ChevronDown } from 'lucide-react';

// Helper function to get the symbol image
const getSymbolImage = (symbolName, isDarkMode) => {
  const mode = isDarkMode ? 'dark' : 'light';
  return `/symbols/${symbolName}.${mode}.png`;
};

const DropdownButton = ({ selectedModel, isOpen, onClick, isDarkMode, variant = 'default' }) => {
  
  const getIcon = useCallback((option) => {
    if (option && option.symbol) {
      return (
        <img
          src={getSymbolImage(option.symbol, isDarkMode)}
          alt={option.display}
          className="w-7 h-7 object-contain"
        />
      );
    }
    return null;
  }, [isDarkMode]);

  if (variant === 'composer') {
    return (
      <button
        type="button"
        onClick={onClick}
        className={`h-9 max-w-[132px] sm:max-w-[190px] px-2.5 rounded-full flex items-center gap-1.5 transition-colors duration-150 ${
          isDarkMode
            ? 'text-gray-300 hover:bg-white/10'
            : 'text-gray-600 hover:bg-black/5'
        } ${isOpen ? 'bg-black/5 dark:bg-white/10' : ''}`}
        aria-label="Select model"
      >
        <span className="truncate text-sm font-medium leading-none">
          {selectedModel?.display || 'Model'}
        </span>
        <ChevronDown
          className={`flex-shrink-0 transition-transform duration-150 ${
            isOpen ? 'transform rotate-180' : ''
          }`}
          size={15}
        />
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={onClick}
      className={`w-full h-12 px-3 text-left rounded-2xl flex items-center justify-between transition-all duration-150 border shadow-sm ${
        isDarkMode
          ? 'bg-white/5 border-white/10 text-white hover:bg-white/10'
          : 'bg-white border-black/10 text-gray-900 hover:bg-gray-50'
      } ${isOpen ? 'ring-2 ring-blue-500/80 shadow-[0_0_0_1px_rgba(59,130,246,0.35)]' : ''}`}
    >
      <div className="flex items-center flex-grow min-w-0 gap-2">
        <div className="flex-shrink-0 w-7 h-7 flex items-center justify-center rounded-xl bg-gray-100 dark:bg-white/10">
          {getIcon(selectedModel)}
        </div>
        <div className="flex flex-col min-w-0">
          <span className="text-base font-semibold leading-tight truncate">{selectedModel?.display || 'Model'}</span>
        </div>
      </div>
      <ChevronDown
        className={`transition-transform duration-150 text-gray-400 ${
          isOpen ? 'transform rotate-180' : ''
        }`}
        size={18}
      />
    </button>
  );
};

export default DropdownButton;
